/*
 * @Date: 2019-05-21 13:57:58
 * @Description: 工具函数
 */
import Vue from 'vue'
import { WS_URL, USER_INFO, USER_TOKEN } from '@/config/const'
import authUtil from '@/render/utils/auth'
import store from 'store'
import $store from '@/render/store'
/**
 * 例子:
 * export const abslyByArr = arr => arr.map(value => Math.abs(value))
 */

// token 格式化
export function authorizationFormat(token) {
  return `${token}`
}

// 去重
export function uniques(arr) {
  let uniqueArray = arr.filter(function (elem, index, self) {
    return index === self.indexOf(elem)
  })
  return uniqueArray
}

// 获取地址栏参数
export function getUrlParams() {
  const url = window.location.href // 获取url中"?"符后的字串
  const params = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      params[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
    }
  }
  return params
}

// 根据积分获取对应称号
export function getDesignationByScore(score) {
  if (score < 100) return ''
  else if (score >= 100 && score < 199) return '15级棋士'
  else if (score >= 200 && score < 299) return '14级棋士'
  else if (score >= 300 && score < 399) return '13级棋士'
  else if (score >= 400 && score < 499) return '12级棋士'
  else if (score >= 500 && score < 599) return '11级棋士'
  else if (score >= 600 && score < 699) return '10级棋士'
  else if (score >= 700 && score < 799) return '9级棋士'
  else if (score >= 800 && score < 899) return '8级棋士'
  else if (score >= 900 && score < 999) return '7级棋士'
  else if (score >= 1000 && score < 1099) return '6级棋士'
  else if (score >= 1100 && score < 1199) return '5级棋士'
  else if (score >= 1200 && score < 1299) return '4级棋士'
  else if (score >= 1300 && score < 1399) return '3级棋士'
  else if (score >= 1400 && score < 1499) return '2级棋士'
  else if (score >= 1500 && score < 1599) return '1级棋士'
  else if (score >= 1600 && score < 1699) return '棋协候补大师'
  else if (score >= 1700 && score < 1799) return '棋协大师'
  else if (score >= 1800 && score < 1949) return '棋联候补大师'
  else if (score >= 1950 && score < 2099) return '棋联大师'
  else if (score >= 2100 && score < 2299) return '国家大师'
  else if (score >= 2300 && score < 2499) return '国际大师'
  else if (score >= 2500) return '国际特级大师'
}

export function isWhite(turn) {
  return /^b/.test(turn)
}

export function copyText(text, callback) {
  // text: 要复制的内容， callback: 回调
  var tag = document.createElement('input')
  tag.setAttribute('id', 'cp_hgz_input')
  tag.value = text
  document.getElementsByTagName('body')[0].appendChild(tag)
  document.getElementById('cp_hgz_input').select()
  document.execCommand('copy')
  document.getElementById('cp_hgz_input').remove()
  if (callback) {
    callback(text)
  }
}

// 初始化ws连接
export function initWebsocket() {
  const token = authUtil.getToken()
  var ws = new WebSocket(WS_URL)

  ws.emit = function (data) {
    ws.send(typeof data === 'string' ? data : JSON.stringify(data))
  }

  Vue.prototype.$socket = ws

  ws.onopen = function (data) {
    // Web Socket 已连接上，使用 send() 方法发送数据
    var testData = {
      token,
      type: 'user.login',
    }
    ws.send(JSON.stringify(testData))
    console.log('初始化中...')
  }

  ws.onclose = function () {
    // 关闭 websocket
    console.log('连接已关闭...')
    initWebsocket()
  }
}

// 计算等级分浮动系数
export const calcK = (R = 400) => {
  let K = 0
  if (R < 2000) {
    K = 50
  } else if (R < 2400) {
    K = 25
  } else {
    K = 15
  }

  return K
}

// 计算等级分
export const calcGradeScore = (Ra, Rb, Sa) => {
  const Ea = 1 / (1 + Math.pow(10, (Rb - Ra) / 400))

  const RaK = calcK(Ra)
  const Ra_ = Ra + RaK * (Sa - Ea)

  return Math.round(Ra_)
}

/**
 * 获取对局类型
 * @param {number} 对局时长（分钟）
 */
export const getModeType = (time) => {
  if (!time) return -1

  time = +time

  if (time >= 6) {
    return 0
  } else if (time >= 3) {
    return 1
  } else {
    return 2
  }
}
export function dateFormat(fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
      )
    }
  }
  return fmt
}

export function initStockFish() {
  const engine = new Worker('/assets/js/stockfish.js')
  function uciCmd(cmd, which) {
    console.log('UCI: ' + cmd)
    ;(which || engine).postMessage(cmd)
  }
  return {
    engine,
    uciCmd,
  }
}

export function clearLoginStatus() {
  store.remove(USER_INFO)
  store.remove(USER_TOKEN)
  $store.commit('auth/removeToken')
}

export function debounce(fn, wait = 500, immediate = true) {
  let timer
  return function (...params) {
    if (timer) clearTimeout(timer)
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (callNow) {
        fn.apply(this, params)
      }
    } else {
      timer = setTimeout(() => {
        fn.apply(this, params)
      }, wait)
    }
  }
}

export const getScoreLevel = function (score, passScore) {
  if (score === 100) {
    return 0
  }
  if (score >= 90 && score <= 99) {
    return 1
  }
  if (score >= passScore && score <= 89) {
    return 2
  }
  return 3
}
